document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-sav-product]").forEach((section) => {
    const data = section.querySelector("[data-product-variants]");
    const variantId = section.querySelector("[data-variant-id]");
    const media = Array.from(section.querySelectorAll("[data-media-id]"));
    if (!data || !variantId || !media.length) return;
    let variants;
    try { variants = JSON.parse(data.textContent); } catch (error) { return; }

    const updateColorVisibility = () => {
      section.querySelectorAll(".sav-option-group--color .sav-option-input").forEach((input) => {
        const label = section.querySelector(`label[for="${CSS.escape(input.id)}"]`);
        if (label) label.hidden = input.disabled;
      });
    };

    const showPair = (shouldScroll = false) => {
      const variant = variants.find((item) => String(item.id) === String(variantId.value));
      const mediaId = variant?.featured_media?.id || variant?.featured_image?.id;
      let selectedIndex = media.findIndex((item) => String(item.dataset.mediaId) === String(mediaId));
      if (selectedIndex < 0) selectedIndex = 0;
      const pairStart = Math.floor(selectedIndex / 2) * 2;
      media.forEach((item, index) => {
        const visible = index === pairStart || index === pairStart + 1;
        item.hidden = !visible;
        item.classList.toggle("is-selected", index === pairStart);
      });
      updateColorVisibility();
      if (shouldScroll && window.matchMedia("(max-width: 800px)").matches && media[pairStart]) {
        media[pairStart].scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    };

    section.querySelectorAll(".sav-option-input").forEach((input) => {
      input.addEventListener("change", () => window.requestAnimationFrame(() => showPair(true)));
    });
    showPair();
  });
});
